import { NavLink as Link } from 'react-router-dom';


import styled from 'styled-components';

export const FooterContainer = styled.nav`
    position: relative;
    background: linear-gradient(135deg, #5b9dd0 0%, #53813e 100%);
    padding: 3rem 1rem 2rem 1rem;
    justify-content: center;
    width: 100%;
    display: flex;
    z-index: 98;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
`;

export const LinkChild = styled(Link)`
    color: white;
    text-decoration: none;
    font-size: 14px;
    text-align: center;
    display: block;
    width: 100%;
    font-weight: 500;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.8;
        text-decoration: underline;
    }
`;

export const FooterText = styled.text`
    color: white;
    text-decoration: none;
    padding: .5rem 0 .5rem 0;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: block;
    width: 100%;
`;